import React, { useState } from "react";
import {
  IconButton,
  Button,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import { Feedback as FeedbackIcon } from "@mui/icons-material";
import FeedbackDialog from "./FeedbackDialog";

interface FeedbackButtonProps {
  variant?: "icon" | "button" | "list-item";
  size?: "small" | "medium" | "large";
  color?: "inherit" | "primary" | "secondary";
  sx?: object;
}

const FeedbackButton: React.FC<FeedbackButtonProps> = ({
  variant = "icon",
  size = "medium",
  color = "inherit",
  sx = {},
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const theme = useTheme();

  const handleClick = () => {
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  if (variant === "list-item") {
    return (
      <>
        <ListItemButton onClick={handleClick} sx={sx}>
          <ListItemIcon>
            <FeedbackIcon />
          </ListItemIcon>
          <ListItemText primary="Submit Feedback" />
        </ListItemButton>
        <FeedbackDialog open={dialogOpen} onClose={handleClose} />
      </>
    );
  }

  if (variant === "button") {
    return (
      <>
        <Button
          variant="outlined"
          startIcon={<FeedbackIcon />}
          onClick={handleClick}
          size={size}
          color={color}
          sx={{
            borderRadius: 2,
            textTransform: "none",
            fontWeight: "medium",
            ...sx,
          }}
        >
          Feedback
        </Button>
        <FeedbackDialog open={dialogOpen} onClose={handleClose} />
      </>
    );
  }

  // Default icon variant
  return (
    <>
      <IconButton
        onClick={handleClick}
        size={size}
        color={color}
        aria-label="submit feedback"
        title="Submit Feedback"
        sx={{
          ...(theme.palette.mode === "dark" && {
            color: "white",
          }),
          ...sx,
        }}
      >
        <FeedbackIcon />
      </IconButton>
      <FeedbackDialog open={dialogOpen} onClose={handleClose} />
    </>
  );
};

export default FeedbackButton;
